import request from '@/router/axios'

// 获取腾讯云密钥
export const getCloudKey = (params) => {
  return request({
    url: `/v1/qcloudcossts/getv2`,
    method: "get",
    params,
  });
};



// WEBPACK FOOTER //
// ./src/api/cos.js